<template>
	<div style="background-color: var(--card-type2-color);">
		<PersonalBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>수상/보도</h3>	
				<h4>믿을 수 있는 <br class="visible-xs">중국 전문 배대지<br>압도적 회원수 1위 고로켓고</h4>
				
			</div>
			
			<br>
			
		</div>
		
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	export default {

		components: {
			PersonalBanner
		},
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: #111;
		margin: 60px 0;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--main-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
		color: #fff;
	}
	.visible-xs {
	    display: none !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 0 auto;
			padding: 0 auto;
		}
		
	}
	@media (max-width: 768px) {	

		.visible-xs {
		    display:block !important;
		}
	}
</style>